// Regional utilities for Burkina Faso
export const formatPhoneNumber = (phone: string): string => {
  if (!phone) return '';
  
  // Remove all non-digit characters
  let cleaned = phone.replace(/\D/g, '');
  
  // Remove country code if present
  if (cleaned.startsWith('226')) {
    cleaned = cleaned.substring(3);
  } else if (cleaned.startsWith('00226')) {
    cleaned = cleaned.substring(5);
  }
  
  // Ensure we don't exceed 8 digits
  cleaned = cleaned.slice(0, 8);
  
  // Format as XX XX XX XX
  if (cleaned.length === 0) return '';
  
  const parts = [];
  for (let i = 0; i < cleaned.length; i += 2) {
    parts.push(cleaned.slice(i, i + 2));
  }
  
  return `+226 ${parts.join(' ')}`;
};

export const validatePhoneNumber = (phone: string): boolean => {
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Check if it's a valid Burkina Faso mobile number
  // Valid formats:
  // - 70 12 34 56
  // - 70123456
  // - +226 70 12 34 56
  // - +22670123456
  // - 0022670123456
  // Must start with 70, 71, 72, 75, 76, 77, 78, or 79 and be 8 digits long
  const regex = /^(\+226|00226)?[67]\d{7}$/;
  return regex.test(cleaned);
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('fr-BF', {
    style: 'currency',
    currency: 'XOF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const formatDate = (date: Date | string): string => {
  return new Date(date).toLocaleDateString('fr-BF', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatTime = (date: Date | string): string => {
  return new Date(date).toLocaleTimeString('fr-BF', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

// Common cities in Burkina Faso
export const BURKINA_FASO_CITIES = [
  'Ouagadougou',
  'Bobo-Dioulasso',
  'Koudougou',
  'Banfora',
  'Ouahigouya',
  'Kaya',
  'Tenkodogo',
  'Dédougou',
  'Dori',
  'Diapaga'
];
